import { ReactNode } from 'react';
import { URLSearchParamsInit, useLocation } from 'react-router-dom';
import css from './page-header.module.scss';
import * as routes from 'src/constants/routes';
import UafPattern from 'src/components/uaf-pattern/uaf-pattern';
import ProposeEventPopup from 'src/pages/events/event-proposition/propose-event';
import ProposeLocationPopup from 'src/pages/business-map/propose-location/propose-location';
import ProposeServicePopup from 'src/pages/services/service-proposition/propose-service';
import ProposeNewsPopup from 'src/pages/news/news-poposition/propose-news';
import Breadcrumbs from 'src/components/breadcrumbs/breadcrumbs';
import RequestEmailModal from '../request-modal/request-email-modal';

interface PageHeaderProps {
  title: string;
  description: string;
  pages?: { path: string; title: string }[];
  filter?: ReactNode;
  subFilter?: ReactNode;
  searchParams?: URLSearchParamsInit;
}

export default function PageHeader({
  title,
  description,
  pages,
  filter,
  subFilter,
  searchParams
}: Readonly<PageHeaderProps>) {
  const location = useLocation();

  return (
    <div className={css.header}>
      <div className={css.container}>
        <div className={css.info}>
          <div className={css.textGroup}>
            <Breadcrumbs title={title} pages={pages} searchParams={searchParams} />
            <h1>{title}</h1>
            <p>{description}</p>
            {filter}
          </div>
          {location.pathname.startsWith(routes.EVENTS.path) && (
            <ProposeEventPopup trigger={<button className={css.proposeButton}>Запропонувати подію</button>} />
          )}
          {location.pathname.startsWith(routes.BUSINESS_MAP.path) && (
            <ProposeLocationPopup trigger={<button className={css.proposeButton}>Запропонувати локацію</button>} />
          )}
          {location.pathname.startsWith(routes.PARTNERSHIP.path) && (
            <RequestEmailModal
              title='Запропонувати партнерство'
              trigger={<button className={css.proposeButton}>Запропонувати партнерство</button>}
            />
          )}
          {(location.pathname.startsWith(routes.CAREER_INFO.path) ||
            location.pathname.startsWith(routes.EDUCATION_INFO.path) ||
            location.pathname.startsWith(routes.PSYCHOLOGICAL_HELP.path) ||
            location.pathname.startsWith(routes.MEDICAL_SERVICES.path) ||
            location.pathname.startsWith(routes.LEGAL_HELP.path) ||
            location.pathname.startsWith(routes.USEFUL_INFO.path) ||
            location.pathname.startsWith(routes.VETERAN_LOCATIONS.path)) && (
            <ProposeServicePopup
              includeLocation={location.pathname.startsWith(routes.VETERAN_LOCATIONS.path)}
              trigger={<button className={css.proposeButton}>Запропонувати послугу</button>}
            />
          )}
          {location.pathname.startsWith(routes.NEWS.path) && (
            <ProposeNewsPopup trigger={<button className={css.proposeButton}>Запропонувати новину</button>} />
          )}
        </div>
        {subFilter}
        <UafPattern />
      </div>
    </div>
  );
}
